import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  CircularProgress,
  Switch,
  TableFooter,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
} from "@material-ui/core";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import axios from "axios";

const useRowStyles = makeStyles(({ dense }) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },

    "&:hover": { backgroundColor: "#dbdbdb" },
    "& .MuiButtonBase-root": {
      padding: ".2rem",
    },
  },
  avatarName: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: ".5rem",
  },
}));

function Row(props) {
  const { row, token } = props;
  const [open, setOpen] = React.useState(false);
  const [userDetails, setUserDetails] = React.useState("");

  const classes = useRowStyles();

  const getUserDetails = async () => {
    setOpen(!open);

    try {
      if (!open) {
        const response = await axios.post(
          "/.netlify/functions/server/api/management",
          {
            link: `users-by-email?email=${row?.email}`,
            token: token,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );

        setUserDetails(response?.data);
      }
    } catch (err) {
      console.log("Error on Account details: ", err.message);
    }
  };

  const deleteUserDetails = async (user_id) => {
    try {
      console.log("Trying to delete: ", user_id);
      //   const response = await axios.post(
      //     "/.netlify/functions/server/api/management",
      //     {
      //       link: `users/${user_id}`,
      //       token: token,
      //     },
      //     {
      //       headers: {
      //         Authorization: `Bearer ${localStorage.getItem("userToken")}`,
      //       },
      //     }
      //   );
    } catch (err) {
      console.log("Error on Account details: ", err.message);
    }
  };

  const removeUserRole = async (user_id) => {
    try {
      const role_id = "rol_gxeBdwsIR8xJC5u7"; //superAdmin
      console.log("REMOVING ");
      const response = await axios.put(
        "/.netlify/functions/server/api/management",
        {
          link: `users/${user_id}/roles`,
          token: token,
          roles: role_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );

      console.log("REMOVED: ", response);
    } catch (err) {
      console.log("Error on Remove Role: ", err.message);
    }
  };

  const addUserRole = async (user_id) => {
    try {
      const role_id = "rol_gxeBdwsIR8xJC5u7"; //superAdmin

      console.log("Adding ");

      const response = await axios.post(
        "/.netlify/functions/server/api/management",
        {
          link: `users/${user_id}/roles`,
          token: token,
          roles: role_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );

      console.log("Added: ", response);
    } catch (err) {
      console.log("Error on Adding Role: ", err.message);
    }
  };

  return (
    <>
      <TableRow className={classes.root} key={row?.name}>
        <TableCell align="center" style={{ width: "5%" }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={getUserDetails}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="td" scope="row" align="right">
          <span className={classes.avatarName} style={{}}>
            <Avatar alt={`${row?.name}`} src={`${row?.picture}`} />
            {row?.name}
          </span>
        </TableCell>
        <TableCell align="center">{row?.email}</TableCell>
        <TableCell align="center">
          {[1, 2].map(() => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: ".2rem 0",
              }}
            >
              <span
                style={{
                  border: ".1rem solid grey",
                  padding: ".1rem .5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Admin
              </span>
              <IconButton
                title="Remove role"
                color="secondary"
                onClick={() => removeUserRole(row?.user_id)}
              >
                <CancelIcon />
              </IconButton>
            </div>
          ))}

          <IconButton
            title="Add News Role"
            color="primary"
            onClick={() => addUserRole(row?.user_id)}
          >
            <AddCircleIcon />
          </IconButton>
        </TableCell>
        <TableCell align="center">
          <IconButton>
            <DeleteIcon
              color="secondary"
              onClick={() => removeUserRole(row?.user_id)}
            />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              margin={1}
              padding={0.5}
              style={{ backgroundColor: "#5888a529", textAlign: "center" }}
            >
              <Typography variant="h6" gutterBottom component="div">
                Account Details
              </Typography>
              {!userDetails ? (
                <CircularProgress />
              ) : (
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow style={{ border: " .08rem solid #fff" }}>
                      <TableCell align="center">Email Veified</TableCell>
                      <TableCell align="center">Login count</TableCell>
                      <TableCell align="center">Last Ip</TableCell>
                      <TableCell align="center">Last Login</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {userDetails?.map((user) => (
                      <TableRow
                        key={user?.email}
                        style={{ border: " .08rem solid #fff" }}
                      >
                        <TableCell component="th" scope="row" align="center">
                          {`${user?.email_verified}`}
                        </TableCell>
                        <TableCell align="center">
                          {user?.logins_count}
                        </TableCell>
                        <TableCell align="center">{user?.last_ip}</TableCell>
                        <TableCell align="center">{user?.last_login}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

export default function AllAccount(props) {
  // Name, No of news, Role, delete

  const { token } = props;
  const [rows, setRows] = React.useState();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [dense, setDense] = React.useState(false);

  const [roleId, setRoleId] = React.useState();
  const [roles, setRoles] = React.useState();
  const [open, setOpen] = React.useState(false);

  const classes = useStyles2(dense);

  React.useEffect(() => {
    (async () => {
      try {
        const res = await axios.post(
          "/.netlify/functions/server/api/management",
          {
            link: `roles`,
            token: token,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        setRoles(res?.data);
      } catch (err) {
        console.error("2 ", err.message);
      }
    })();
  }, []);

  const handleClick = async (e) => {
    try {
      setRoleId(e.target.value);

      const res = await axios.post(
        "/.netlify/functions/server/api/management",
        {
          link: `roles/${await e.target.value}/users`,
          token: await token,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );

      setRows(res?.data);
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows?.length - page * rowsPerPage);

  return (
    <>
      <FormControl variant="filled" className={classes.formControl}>
        <InputLabel id="demo-controlled-open-select-label">Role</InputLabel>
        <Select
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          value={roleId}
          onChange={handleClick}
        >
          <MenuItem value="" disabled>
            <em>Select a role</em>
          </MenuItem>
          {roles?.map((role) => (
            <MenuItem value={role?.id} title={role?.description}>
              {role?.name?.toUpperCase()}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table" className={classes.root1}>
          <TableHead>
            <TableRow className={classes.tHead}>
              <TableCell align="center" />
              <TableCell align="center">Admin Name</TableCell>
              <TableCell align="center">No of news</TableCell>
              <TableCell align="center">Role</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{ textAlign: "center" }}>
            {rows ? (
              (rowsPerPage > 0
                ? rows?.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : rows
              )?.map((row) => <Row key={row?.name} row={row} token={token} />)
            ) : (
              <TableRow>
                <TableCell colSpan={5} style={{ textAlign: "center" }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            )}

            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={5} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell align="center">
                <Switch checked={dense} onChange={() => setDense(!dense)} />{" "}
                Dense Data
              </TableCell>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                colSpan={5}
                count={rows?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      {/* <pre>{JSON.stringify(test, null, 2)}</pre> */}
    </>
  );
}

const useStyles2 = makeStyles(({ dense }) => ({
  root1: {
    minWidth: 500,
    "&  td": {
      padding: (dense) => (dense ? "0 .5rem" : "1rem "),
    },
  },
  tHead: {
    backgroundColor: "#343d34",
    "& th": {
      color: "white",
    },
  },
  formControl: {
    "& #demo-controlled-open-select": {
      minWidth: "5rem",
    },
  },
}));
